import React from 'react';
import { AndroidOutlined } from '@ant-design/icons';
import Icon from 'src/componets/Icon';

const ANDROID_GREEN = '#52C41A';

const PlatformIcon = ({ platform }: { platform: 'ios' | 'android' }) => (
  platform === 'android'
    ? <AndroidOutlined style={{ color: ANDROID_GREEN }} />
    : <Icon icon='fa-brands fa-apple' />
);

export default PlatformIcon;
